import React from "react";
import Perks1 from "../../assets/Career/Perks1.svg";
import Perks2 from "../../assets/Career/Perks2.svg";
import Perks3 from "../../assets/Career/Perks3.svg";
import TagButton from "../common/TagButton";

const perks = [
  {
    icon: Perks1,
    title: (
      <>
        Working On The Edge <br /> Of Innovation
      </>
    ),
    number: "1",
    numberClass:
      "absolute right-[32px] md:left-[236px] bottom-[127px] top-[-60px] font-roboto text-[122.093px] font-semibold bg-gradient-to-b from-[#D6D7DB] to-white bg-clip-text text-transparent z-0 pointer-events-none",
  },
  {
    icon: Perks2,
    title: (
      <>
        Grow With Technologists <br /> Who’ve Done It Before
      </>
    ),
    number: "2",
    numberClass:
      "absolute top-[-60px] right-[32px] md:left-[236px] bottom-[127px] font-roboto text-[122.093px] font-semibold bg-gradient-to-b from-[#D6D7DB] to-white bg-clip-text text-transparent z-0 pointer-events-none",
  },
  {
    icon: Perks3,
    title: (
      <>
        Create IP, Not Just The <br /> Output
      </>
    ),
    number: "3",
    numberClass:
      "absolute top-[-60px] right-[32px] md:left-[236px] bottom-[127px] font-roboto text-[122.093px] font-semibold bg-gradient-to-b from-[#D6D7DB] to-white bg-clip-text text-transparent z-0 pointer-events-none",
  },
];

const WhatYouCanExpect = () => (
  <section className="relative md:flex flex-col gap-[36px] items-center w-full mt-10 px-[20px] md:px-0">
    {/* Grid background lines */}
    <div
      className="absolute inset-0 z-0 pointer-events-none"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='0' width='10' height='30' fill='none'/%3E%3Crect x='0' y='0' width='30' height='10' fill='none'/%3E%3Cline x1='10' y1='0' x2='10' y2='30' stroke='%23e5e5e5' stroke-width='1' stroke-opacity='0.5' stroke-dasharray='4,4'/%3E%3Cline x1='0' y1='10' x2='30' y2='10' stroke='%23e5e5e5' stroke-width='1' stroke-opacity='0.5' stroke-dasharray='4,4'/%3E%3C/svg%3E")`,
        backgroundSize: "30px 30px",
      }}
    />

    {/* Heading and Subtext */}
    <div className="md:max-w-[1200px] w-full md:mb-0 mb-[36px] z-[1]">
      <TagButton text="Perks n' Benefits" />
    </div>
    <div className="md:max-w-[1200px] w-full flex flex-col items-start z-[1]">
      <h2
        className="font-montserrat font-semibold text-[24px] md:text-[40px] leading-[53px] text-transparent bg-clip-text md:w-[480px]"
        style={{
          background: "linear-gradient(90deg, #000 0%, #0060C7 81.7%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        What You Can Expect
      </h2>
      <p className="text-[#444] font-roboto font-light text-[16px] leading-[28px] mt-4 w-full md:w-[1000px]">
        At Think41, experienced professionals don’t just manage—they build,
        learn, and lead in ways that stay ahead of the curve.
      </p>
    </div>

    {/* Perks Row */}
    <div className="pt-[72px] flex flex-col md:flex-row justify-center items-center w-full md:max-w-[1200px] relative gap-[0px] xl:gap-[100px] z-[1]">
      {perks.map((perk, idx) => (
        <React.Fragment key={idx}>
          <div className="flex flex-col items-start relative w-full md:w-[330px] xl:w-[353px] h-[220px] z-[1]">
            <div className="flex justify-between m-[-15px]">
              <span>
                <img
                  src={perk.icon}
                  alt={`icon-${idx + 1}`}
                  className="flex-shrink-0 relative md:left-[-20px] top-[-12px]"
                />
              </span>
              <span className={perk.numberClass}>{perk.number}</span>
            </div>
            <div className="font-montserrat font-semibold text-[22px] leading-[30px] text-[#222] text-left tracking-[-0.403px] w-full min-h-[60px] z-[2] relative -bottom-[53px] -top-[12px]">
              {perk.title}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  </section>
);

export default WhatYouCanExpect;
